import ButtonSymphony from "elements/ButtonSymphony"
import ModalSymphony from "elements/ModalSymphony"
import useBrand from "Hooks/useBrand"
import useOrganizationV2 from "Hooks/useOrganizationV2"
import { CurrentBrand } from "modules/Types"

interface DeleteBrandConfirmationModalProps {
    isOpen: boolean
    onClose: () => void
    onDeleteAction: () => Promise<void>
}

const DeleteBrandConfirmationModal = ({
    isOpen,
    onClose,
    onDeleteAction,
}: DeleteBrandConfirmationModalProps) => {
    const { isLoadingBrand } = useBrand()
    const { getSelectedBrand, isLoadingOrganizationAction } = useOrganizationV2()

    const selectedBrand = getSelectedBrand() as CurrentBrand;

    return (
        <ModalSymphony
            className="deleteBrandConfirmationModal"
            title="Are you sure you want to remove this brand?"
            isOpen={isOpen}
            onClose={onClose}
            buttonLeftText="Cancel"
            onClickButtonLeft={onClose}
            onClickButtonRight={onDeleteAction}
            buttonRightText="Confirm"
            buttonLeftColor="grey"
            buttonRightColor="red"
            buttonLeftVariant="text"
            buttonRightVariant="outlined"
            buttonRightIsLoading={isLoadingBrand || isLoadingOrganizationAction}
            buttonLeftIsLoading={isLoadingBrand || isLoadingOrganizationAction}
        >
            <div className="flex gap-4 items-center">
                This will remove access to {selectedBrand?.name} from all users in your organization.
            </div>
        </ModalSymphony>
    )
}

export default DeleteBrandConfirmationModal